import { render, staticRenderFns } from "./StakeInfo.vue?vue&type=template&id=88dc0792&scoped=true&"
import script from "./StakeInfo.vue?vue&type=script&lang=ts&"
export * from "./StakeInfo.vue?vue&type=script&lang=ts&"
import style0 from "./StakeInfo.vue?vue&type=style&index=0&id=88dc0792&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88dc0792",
  null
  
)

export default component.exports